import cx from 'clsx';
import {
  IconBulletPointFilled,
  IconCheckmarkOutlined,
  IconCrossOutlined,
} from '@repo/monochrome-icons';
import type { PropsWithChildren, ReactNode } from 'react';
import styles from './item.module.css';

export interface ListItemProps extends PropsWithChildren {
  icon?: 'bullet' | 'check' | 'cross';
}

const getIcon = (icon: ListItemProps['icon']): ReactNode => {
  switch (icon) {
    case 'check':
      return (
        <IconCheckmarkOutlined
          className={styles.icon}
          data-testid="icon-check"
          height={16}
          width={16}
        />
      );
    case 'cross':
      return (
        <IconCrossOutlined
          className={styles.icon}
          data-testid="icon-cross"
          height={16}
          width={16}
        />
      );
    default:
      return (
        <IconBulletPointFilled
          className={styles.icon}
          data-testid="icon-bullet"
          height={16}
          width={16}
        />
      );
  }
};

export function ListItem({ children, icon = 'bullet' }: ListItemProps): ReactNode {
  return (
    <li className={cx('body-standard', styles.item)} data-testid="list-item">
      {getIcon(icon)}
      {children}
    </li>
  );
}
